module.exports = __webpack_public_path__ + "img/logo-main-black.fe6e3334.svg";